import { render, staticRenderFns } from "./_social_spaces.vue?vue&type=template&id=2d913b2d&"
import script from "./_social_spaces.vue?vue&type=script&lang=js&"
export * from "./_social_spaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports